import React, { useEffect } from "react";

// PC/SP切替広告のReactコンポーネント
const AdSence = (props) => {
    useEffect(() => {
        // windowオブジェクトの広告リストを初期化
        if (window.location.hostname == "ourt-ai.work" && !window["adsbygoogle"]){
            window.adsbygoogle = window.adsbygoogle || [];
            //window.adsbygoogle.push({google_ad_client:'ca-pub-4111330154200475',enable_page_level_ads: true});
        }
        // 外部JSを読み込んで広告リストを実際に表示
        const tag = document.createElement('script');
        tag.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4111330154200475';
        tag.async = true;
        tag.crossOrigin = "anonymous"
        document.body.appendChild(tag);
        // アンマウント時にJSタグと広告情報を削除
        return () => {
            document.body.removeChild(tag);
            //admaxads.splice(admaxads.findIndex(ad =>
            //    ad.admax_id === props.id), 1);
            //window["__admax_tag__"] = undefined;
        }
    }, []);
    return window.location.hostname == "ourt-ai.work" ? (<ins className="adsbygoogle"
    style={{display:"block"}}
    data-ad-client="ca-pub-4111330154200475"
    data-ad-slot="9707613486"
    data-ad-format="auto"
    data-full-width-responsive="true"></ins>) : <div>広告</div>
}

export default AdSence